import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ExamService {
  private userUUID: string = '';

  setUUID(uuid: string) {
    this.userUUID = uuid;
  }

  getUUID(): string {
    return this.userUUID;
  }
}
